<router-outlet></router-outlet> 
 <!-- <app-devicedescription></app-devicedescription> -->
  <!-- <app-dashboard></app-dashboard> -->